<template>
  <div>
    <common-dialog
      :title="title"
      :dialogVisible="dialogVisible"
      :width="width"
      @cancel="dialogCancelClick"
      @confirm="dialogConfirmClick"
      @dialog-close="dialogClose"
    >
      <div class="dialog-body-wrap">
        <div v-if="type === 'delete'">确定删除此分类？</div>
        <div v-if="type === 'add' || type === 'edit'">
          <div class="input-wrap">
            <label>分类名称：</label>
            <el-input
              v-model="info.class_name"
              placeholder="请输入名称"
              class="input"
            ></el-input>
          </div>
          <div class="input-wrap">
            <label>序号：</label>
            <el-input
              v-model="info.sort"
              placeholder="请输入序号"
              class="input"
            ></el-input>
          </div>
        </div>
      </div>
    </common-dialog>
  </div>
</template>

<script>
import CommonDialog from "@/components/CommonDialog";

export default {
  props: {
    title: {
      type: String,
      required: true
    },
    dialogVisible: {
      type: Boolean,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    width: {
      type: String,
      default: "30%"
    },
    row: {
      type: Object
    }
  },
  data() {
    return {
      info: {}
    };
  },
  components: {
    CommonDialog
  },
  mounted() {},
  computed: {},
  watch: {
    dialogVisible(val) {
      if (val && (this.type === "edit" || this.type === "add")) {
        this.info = this.row;
      }
    }
  },
  methods: {
    dialogCancelClick() {
      this.$emit("cancel");
    },
    dialogConfirmClick() {
      if (this.type === "add" || this.type === "edit") {
        const { class_name, sort } = this.info;
        if (!class_name) {
          this.$message("请输入分类名称");
          return;
        }
        if (!sort && sort != 0) {
          this.$message("请输入序号");
          return;
        }
      }
      this.$emit("confirm", this.info);
    },
    dialogClose() {
      this.$emit("close");
    }
  }
};
</script>

<style lang='less' scoped>
@import "~@/assets/styles/variables.less";
@import "~@/assets/styles/mixins.less";

.dialog-body-wrap {
  text-align: center;
  .input-wrap {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    label {
      width: 80px;
      margin-right: 20px;
      text-align: right;
    }
    .input {
      flex: 1;
    }
  }
}
</style>